export default "__VITE_ASSET__BoZM25WW__"